if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.querySelector('.cart-drawer__dialog');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "open") {
          const isOpen = target.hasAttribute("open");

          if (isOpen) {
            function reloadBssScript() { 
            // Tìm thẻ script cũ 
                const oldScript = document.querySelector('script\[src$="bss-b2b-v3.js"\]'); 
            if (oldScript) oldScript.remove(); 
            // xóa nó khỏi DOM

            // Tạo thẻ script mới 
            const newScript = document.createElement('script'); 
            newScript.src = oldScript ? oldScript.src.split('?')[0] + '?reload=' + Date.now() : 'https://example.com/js/bss-b2b-v3.js';

            // Khi tải xong thì log lại (không bắt buộc) 
            newScript.onload = () => console.log('reloaded bss-b2b-v3.js');

            // Gắn vào body (hoặc head đều được)
            document.body.appendChild(newScript); }

            // Gọi hàm để reload script 
            reloadBssScript();
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["open"]
    });
  }, 300);
}


// BSS Lock Custom
const accessDeniedMessages = document.querySelectorAll(".bss-lock-price-access-deniend-7074")
accessDeniedMessages.forEach(message => {
  message.href = "https://chloegourmet.co.uk/pages/work-with-us"
});

const hideLoaders = () => {
  const loaders = document.querySelectorAll('.slot-picker-loader');
  
  loaders.forEach(loader => {
    if (!loader.closest('#checkout')) {
      loader.style.setProperty('display', 'none', 'important');
    }
  });
};

hideLoaders();

const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      hideLoaders();
      break; 
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});



